module.exports = __webpack_public_path__ + "static/media/file-download.b8ad71f3.svg";